import React from 'react';
import { Grid, Box } from '@material-ui/core';
import {
  FieldLabelText,
  SummaryItemContainer,
  SummaryIconWrapper,
} from '../UserRequestsStyles';
import { SummaryItemConfig } from '../types';

interface SummaryRequestViewProps {
  items: SummaryItemConfig[];
  columnsPerRow?: 3 | 4;
}

const GRID_MD_BY_COLUMNS_PER_ROW = {
  3: 4,
  4: 3,
} as const;

const SummaryItem: React.FC<SummaryItemConfig> = ({ icon, label, value }) => (
  <SummaryItemContainer>
    <SummaryIconWrapper>{icon}</SummaryIconWrapper>
    <Box>
      <FieldLabelText>{label}</FieldLabelText>
      <Box>{value}</Box>
    </Box>
  </SummaryItemContainer>
);

const SummaryRequestView: React.FC<SummaryRequestViewProps> = ({
  items,
  columnsPerRow = 4,
}) => {
  return (
    <Grid container>
      {items.map((item, index) => (
        <Grid
          key={index}
          item
          xs={12}
          md={GRID_MD_BY_COLUMNS_PER_ROW[columnsPerRow]}
        >
          <SummaryItem icon={item.icon} label={item.label} value={item.value} />
        </Grid>
      ))}
    </Grid>
  );
};

export default SummaryRequestView;
